import React from 'react';
import 'assets/css/placeholder-card.css';

const PlaceholderCard = () => {
    return (
        <div className="placeholder-card">
            {/* Placeholder content */}
        </div>
    );
};

export default PlaceholderCard; // Ensure PlaceholderCard is correctly exported
